import { FC, useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Step, StepButton, Stepper } from "@mui/material"

/** The five top-level pages (merged chats+mailings page). Detail/progress
 *  pages get NO stepper. */
export const WORKFLOW_STEPS = [
  { label: "Боты", path: "/telegram/guest-bots/bots" },
  { label: "Шаблоны", path: "/telegram/guest-bots/templates" },
  { label: "Привязки", path: "/telegram/guest-bots/bindings" },
  { label: "Чаты и рассылки", path: "/telegram/guest-bots/chats" },
  { label: "Логи", path: "/telegram/guest-bots/logs" },
]

export const WorkflowStepper: FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const activeIndex = useMemo(() => {
    const idx = WORKFLOW_STEPS.findIndex(
      (s) =>
        location.pathname === s.path ||
        location.pathname.startsWith(`${s.path}/`),
    )
    return idx
  }, [location.pathname])

  return (
    <Stepper
      nonLinear
      alternativeLabel
      activeStep={activeIndex}
      sx={{
        mb: 2,
        "& .MuiStepLabel-label": { fontSize: 13 },
      }}
    >
      {WORKFLOW_STEPS.map((step, index) => (
        <Step
          key={step.path}
          className={index === activeIndex ? "Mui-active" : undefined}
          completed={index < activeIndex}
        >
          <StepButton color="inherit" onClick={() => navigate(step.path)}>
            {step.label}
          </StepButton>
        </Step>
      ))}
    </Stepper>
  )
}
